import type { SVGProps } from "react";

export const Close = (props: SVGProps<SVGSVGElement>) => {
	return (
		<svg
			width="16"
			height="16"
			viewBox="0 0 16 16"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<path
				d="M11.5 4.5L4.5 11.5M11.5 11.5L4.5 4.5"
				stroke="var(--svg-color, currentColor)"
				strokeWidth="1.5"
				strokeLinecap="round"
			/>
		</svg>
	);
};
